import React from 'react';
import {
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileTextOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { downloadFileUrl, getFileNameFromUrl } from '@/_util/util';
import './index.less';

// 根据扩展名返回对应的类型标识，用于图标/配色
function getFileType(ext) {
  if (ext === 'pdf') return 'pdf';
  if (['doc', 'docx', 'odt', 'rtf'].includes(ext)) return 'word';
  if (['ppt', 'pptx'].includes(ext)) return 'ppt';
  if (['csv', 'xls', 'xlsx'].includes(ext)) return 'excel';
  return 'text';
}

const iconMap = {
  pdf: <FilePdfOutlined />,
  word: <FileWordOutlined />,
  ppt: <FilePptOutlined />,
  excel: <FileExcelOutlined />,
  text: <FileTextOutlined />,
};

// 格式化文件大小（字节 -> 可读）
function formatSize(size) {
  if (!size) return '';
  if (size < 1024) return `${size}B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)}KB`;
  return `${(size / 1024 / 1024).toFixed(1)}MB`;
}

/**
 * 文件卡片：展示文件名/类型图标/大小，点击下载原文件
 * @param {Object} props
 * @param {string} props.url - 文件地址（OSS URL）
 * @param {string} props.name - 文件名（可选，缺省从 url 提取）
 * @param {number} props.size - 文件大小（字节，可选）
 */
const FileCard = ({ url, name, size }) => {
  const fileName = name || getFileNameFromUrl(url);
  const ext = (fileName?.split('.').pop() || '').toLowerCase();
  const type = getFileType(ext);

  const handleDownload = () => {
    downloadFileUrl(url, fileName);
  };

  return (
    <div className="fileCard" onClick={handleDownload}>
      <span className={`fileCardIcon fileCardIcon-${type}`}>
        {iconMap[type]}
      </span>
      <div className="fileCardInfo">
        <div className="fileCardName" title={fileName}>
          {fileName}
        </div>
        {size ? <div className="fileCardSize">{formatSize(size)}</div> : null}
      </div>
      <DownloadOutlined className="fileCardDownload" />
    </div>
  );
};

export default FileCard;
